<template>
  <div class="fc-contest-info">
    <Menu v-if="activeSection.isCreateContest"></Menu>
    <Menu v-if="!key && !activeSection.isCreateContest" :activeSection="activeSection" @goBackToComponent="goBackToComponent"></Menu>
    <div v-if="key">
      <div class="fc-contest-info">
        <loading-state :state="state"></loading-state>
        <div v-if="state.isLoaded() && stateGames.isLoaded()">
          <ReviewContest
          :isEdited="isEdited"
          :contest="contest"
          :games="games"
          @saveContest="saveContest"
          @saveGame="getContestInfo"
          @deleteContest="saveContest"></ReviewContest>
        </div>
      </div>
    </div>
    <div v-else>
      <div id="no-mode-absolute-demo" class="demo">
        <div class="no-mode-absolute-demo-wrapper">
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isCreateContest">
              <ContestInfo :contest="contestInfo" @enableRule="enableRule"></ContestInfo>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isDefaultRule">
              <RulePreview 
                :ruleKey="contestRule" 
                @changeRule="changeRule" 
                @saveRule="saveRuleDefalut"></RulePreview>
            </div>
            </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isDefaultReward">
              <RewardPreview 
                :rewardKey="contestReward" 
                @changeReward="changeReward"
                @saveReward="saveRewardDefault"></RewardPreview>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isChangeRule">
              <el-tabs v-model="activeName">
                <el-tab-pane label="Public Rules" name="first">
                  <RuleChangeWidget 
                    :ruleState="statePublicRules" 
                    :type="'public'" 
                    :changeObj="publicRules" 
                    :rule="contestRule"
                    @editRule="editRule" 
                    @saveRule="saveNewRule" 
                    @createRule="createRule"
                    @updatedRuleInfo="updatedRuleInfo"></RuleChangeWidget>
                </el-tab-pane>
                <el-tab-pane label="My App Rules" name="second">
                  <RuleChangeWidget 
                    :ruleState="stateAppRules" 
                    :type="'app'" 
                    :changeObj="appRules" 
                    :showEdit="true" 
                    :rule="contestRule"
                    @editRule="editRule" 
                    @saveRule="saveNewRule" 
                    @createRule="createRule" 
                    @updatedRuleInfo="updatedRuleInfo"
                    @getAppRules="getAppRules"></RuleChangeWidget>
                </el-tab-pane>
              </el-tabs>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isCreateRule">
              <CreateRuleWrapper :contest="contestInfo" :ruleKey="ruleKey" @rulesaved="rulesaved"></CreateRuleWrapper>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isChangeReward">
              <el-tabs v-model="activeName">
                <el-tab-pane label="Public Rewards" name="first">
                  <loading-state :state="statePublicRewards"></loading-state>
                  <div v-if="statePublicRewards.isLoaded()">
                    <RewardChangeWidget 
                      :type="'public'" 
                      :changeObj="publicRewards" 
                      :reward="contestReward"
                      @editReward="editReward" 
                      @saveReward="saveNewReward" 
                      @createReward="createReward" 
                      @updatedRewardInfo="updatedRewardInfo"></RewardChangeWidget>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="App Rewards" name="second">
                  <loading-state :state="stateAppRewards"></loading-state>
                  <div v-if="stateAppRewards.isLoaded()">
                    <RewardChangeWidget  
                      :type="'app'" 
                      :changeObj="appRewards" 
                      :showEdit="true" 
                      :reward="contestReward"
                      @saveReward="saveNewReward" 
                      @editReward="editReward"
                      @createReward="createReward" 
                      @getAppRewards="getAppRewards"
                      @updatedRewardInfo="updatedRewardInfo"></RewardChangeWidget>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isCreateReward">
              <CreateRewardWrapper :rewardKey="rewardKey" @rewardsaved="rewardsaved"></CreateRewardWrapper>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isSettings">
              <settings :contest="contestInfo" @saveSettings="saveSettings"></settings>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isReviewContest">
              <ReviewContest :isEdited="false" :contest="contestInfo" @saveContest="saveContest"></ReviewContest>
            </div>
          </transition>
          <transition name="no-mode-absolute-fade">
            <div class="show-block" v-if="activeSection.isCreateGame">
              <CreateGameWrapper></CreateGameWrapper>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Enum } from '@/helpers/enum'
import moment from 'moment'
import { UserHome, Contest } from '@/models/fantasyconsole/contest'
import { DataState, WizardManager } from '@/state'
import RulePreview from '@/components/fantasyconsole/RulePreview'
import RewardPreview from '@/components/fantasyconsole/RewardPreview'
import Settings from '@/components/fantasyconsole/Settings'
import ReviewContest from '@/components/fantasyconsole/ReviewContest'
import ContestInfo from '@/components/fantasyconsole/ContestInfo'
import { Rule, Reward } from '@/models/fantasyconsole/rule'
import RuleChangeWidget from '@/components/fantasyconsole/RuleChangeWidget'
import RewardChangeWidget from '@/components/fantasyconsole/RewardChangeWidget'
import CreateRuleWrapper from '@/components/fantasyconsole/CreateRuleWrapper'
import CreateRewardWrapper from '@/components/fantasyconsole/CreateRewardWrapper'
import CreateGameWrapper from '@/components/fantasyconsole/CreateGameWrapper'

export const Step = new Enum({
  CreateContest: 'Create Contest',
  DefaultRule: 'Default rule',
  ChangeRule: 'Change Rule',
  CreateRule: 'Create Rule',
  DefaultReward: 'Default Reward',
  ChangeReward: 'Change Rule',
  CreateReward: 'Create Reward',
  Settings: 'Additional settings',
  ReviewContest: 'Review Contest',
  CreateGame: 'Create Game'
})

export default {
  components: {
    RulePreview,
    RewardPreview,
    Settings,
    ReviewContest,
    ContestInfo,
    RuleChangeWidget,
    RewardChangeWidget,
    CreateRuleWrapper,
    CreateRewardWrapper,
    CreateGameWrapper
  },
  data () {
    return {
      home: {},
      contest: {},
      rule: null,
      state: DataState.newLoading(),
      stateAppRules: DataState.newLoading(),
      statePublicRules: DataState.newLoading(),
      stateAppRewards: DataState.newLoading(),
      statePublicRewards: DataState.newLoading(),
      contestInfo: new Contest(),
      wizardManager: WizardManager,
      sections: Step,
      activeSection: Step.CreateContest,
      key: this.$route.params.key,
      games: [],
      gamesCursor: null,
      isEdited: false,
      stateGames: DataState.newLoading(),
      publicRules: {},
      appRules: {},
      publicRewards: {},
      appRewards: {},
      activeName: 'first',
      ruleKey: null,
      rewardKey: null,
      contestRule: null,
      contestReward: null,
      wizardManager: {}
    }
  },
  mounted () {
    this.wizardManager = JSON.parse(localStorage.getItem('wizardManager'))

    if (this.$route.params.key) {
      this.key = this.$route.params.key
      this.isEdited = true
      this.getContestInfo()
    } else {
      this.getDefalutContest()
    }

  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.getContestInfo()
      } else {
        this.getContestInfo()
      }
    },
    'activeSection' () {
      if (this.activeSection.isChangeRule) {
        this.getAllrules()
        this.getAppRules()
      } else if (this.activeSection.isChangeReward) {
        this.getAllreward()
        this.getAppRewards()
      }
    }
  },

  methods: {
    getWizardmanager () {
      if (this.wizardManager) {
        for (let section of this.wizardManager.flow) {
          const found = WizardManager.flow.some(el => el.key === section.key)
          if (!found) {
            WizardManager.flow.push(section)
          }
        }
        this.activeSection = Step[WizardManager['flow'][WizardManager.flow.length - 1]['key']]
        this.contestInfo = this.wizardManager.stateData
        if (this.wizardManager.stateData.rule) { this.contestRule = this.wizardManager.stateData.rule }
        if (this.wizardManager.stateData.reward) {this.contestReward = this.wizardManager.stateData.reward }
      } else {
        WizardManager.createWizard(this.activeSection, this.contestInfo)
      }
    },

    getDefalutContest () {
      UserHome.fetch().then((resp) => {
        this.home = resp
        this.contestRule = this.home.rule.key
        this.contestReward = this.home.rewards.key
        this.getWizardmanager()
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
    getContestInfo () {
      this.key = this.$route.params.key
      if (this.key) {
        Contest.getContest(this.key).then((resp) => {
          this.contest = resp
          this.state.changeToLoaded()
          return Contest.games(this.contest.key)
        }).then((resp) => {
          this.games = resp.previews
          this.gamesCursor = resp.cursor
          this.stateGames.changeToLoaded()
        }).catch((error) => {
          this.state.changeToError(error)
        })
      }
    },
    goBackToComponent (page) {
      this.activeSection = Step[page['key']]
    },
    enableRule (e) {
      this.activeSection = Step.DefaultRule
      WizardManager.createWizard(Step.DefaultRule, this.contestInfo)
    },
    rulesaved () {
      this.changeRule()
      WizardManager.flow.pop()
      WizardManager.stateData = this.contestInfo
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    },
    rewardsaved () {
      this.changeReward()
      WizardManager.flow.pop()
      WizardManager.stateData = this.contestInfo
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    },
    updatedRuleInfo (ruleInfo, type) {
      if (type === 'app') {
        this.appRules = ruleInfo
      } else {
        this.publicRules = ruleInfo
      }
    },
    updatedRewardInfo (rewardInfo, type) {
      if (type === 'app') {
        this.appRewards = rewardInfo
      } else {
        this.publicRewards = rewardInfo
      }
    },
    saveNewRule (e, type) {
      this.contestInfo.rule = e
      this.contestRule = e
      if (type !== 'rulePreview') {
        WizardManager.flow.pop()
        WizardManager.stateData = this.contestInfo
        localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
      }
      this.activeSection = Step.DefaultRule
      WizardManager.createWizard(Step.DefaultRule, this.contestInfo)
    },
    saveRuleDefalut (e, type) {
      this.contestInfo.rule = e
      if (type !== 'rulePreview') {
        
        
      }
      this.activeSection = Step.DefaultReward
      WizardManager.createWizard(Step.DefaultReward, this.contestInfo)
    },
    saveNewReward (e, type) {
      this.contestInfo.reward = e
      this.contestReward = e
      if (type !== 'rewardPreview') {
        WizardManager.flow.pop()
        WizardManager.stateData = this.contestInfo
        localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
      }
      this.activeSection = Step.DefaultReward
      WizardManager.createWizard(Step.DefaultReward, this.contestInfo)
    },
    saveRewardDefault (e, type) {
      this.contestInfo.reward = e
      if (type !== 'rewardPreview') {
        WizardManager.flow.pop()
        WizardManager.stateData = this.contestInfo
        localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
      }
      this.activeSection = Step.Settings
      WizardManager.createWizard(Step.Settings, this.contestInfo)
    },
    saveSettings (e) {
      this.activeSection = Step.ReviewContest
      WizardManager.createWizard(Step.ReviewContest, this.contestInfo)
    },
    saveContest (contest) {
      let payload
      if (contest.key) {
        contest.points_setup = { 'points_model': contest.pointsystem.key, 'boosts_rate': [2.5] }
        payload = contest
        content.leaderboard = contest.have_leaderboard
      } else {
        payload = this.contestInfo
      }
      Contest.createContest(payload).then((resp) => {
        this.contest = resp.data
        this.$notify({
          title: 'Success',
          message: 'Contest saved successfully',
          type: 'success'
        })
        this.getContestInfo()
        this.state.changeToLoaded()
        if (contest.is_archived) {
          this.$router.push({ name: 'FCHome'})
        }
        if (this.key) {
        } else {
          if (this.contest && this.contest.key) {
            this.$router.push({ name: 'ContestConfirmation', params: { key: this.contest.key } })
          }
        }
      }).catch((error) => {
        this.state.changeToError(error)
        if (this.state.msg.response.data.error) {
          this.$notify({
            title: 'Error',
            message: this.state.msg.response.data.error.msg,
            type: 'error'
          })
        }
      })
    },
    dateOperation (selectedTime, at) {
      let timestamp = moment.utc(selectedTime).format('X')
      return parseInt(timestamp) + (5.5 * 60 * 60)
    },
    changeRule () {
      this.getAllrules()
      this.getAppRules()
      this.activeSection = Step.ChangeRule
      WizardManager.createWizard(Step.ChangeRule, this.contestInfo)
    },
    getAllrules () {
      Rule.getAllRules().then((resp) => {
        this.publicRules = resp
        this.statePublicRules.changeToLoaded()
      }).catch((error) => {
        this.statePublicRules.changeToError(error)
      })
    },
    getAppRules () {
      Rule.getAppRules().then((resp) => {
        this.appRules = resp
        console.log('app rules', this.appRules)
        this.stateAppRules.changeToLoaded()
      }).catch((error) => {
        this.stateAppRules.changeToError(error)
      })
    },
    createRule () {
      this.ruleKey = null
      this.activeSection = Step.CreateRule
      WizardManager.createWizard(Step.CreateRule, this.contestInfo)
    },
    createReward () {
      this.rewardKey = null
      this.activeSection = Step.CreateReward
      WizardManager.createWizard(Step.CreateReward, this.contestInfo)
    },
    changeReward () {
      this.getAllreward()
      this.getAppRewards()
      this.activeSection = Step.ChangeReward
      WizardManager.createWizard(Step.ChangeReward, this.contestInfo)
    },
    getAllreward () {
      Reward.getAllRewards().then((resp) => {
        this.publicRewards = resp
        this.statePublicRewards.changeToLoaded()
      }).catch((error) => {
        this.statePublicRewards.changeToError(error)
      })
    },
    getAppRewards () {
      Reward.getAppRewards().then((resp) => {
        this.appRewards = resp
        this.stateAppRewards.changeToLoaded()
      }).catch((error) => {
        this.stateAppRewards.changeToError(error)
      })
    },
    editRule (key) {
      this.ruleKey = key
      this.activeSection = Step.CreateRule
      WizardManager.createWizard(Step.CreateRule, this.contestInfo)
    },
    editReward (key) {
      this.rewardKey = key
      this.activeSection = Step.CreateReward
      WizardManager.createWizard(Step.CreateReward, this.contestInfo)
    }
  }
}
</script>
<style lang="scss">
  .el-select-dropdown {
    ul li {
      span {
        font-family: "proxima-nova", sans-serif;
        color: #333;
        font-size: 15px;
      }
    }
  }
</style>
